export default __webpack_public_path__ + "static/media/me-icon-bottom-nav-mobile-active.8192df44.webp";